// Hjälpfunktioner för att räkna ut kommande datum för en viss veckodag.

const MONTHS = [
  'januari',
  'februari',
  'mars',
  'april',
  'maj',
  'juni',
  'juli',
  'augusti',
  'september',
  'oktober',
  'november',
  'december',
]

export type WeekdayOption = {
  /** ISO-datum, t.ex. 2026-09-03 */
  value: string
  /** Visningsnamn, t.ex. "3 september" */
  label: string
  /** "Denna vecka", "Nästa vecka" eller tomt */
  hint: string
}

function toIso(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/** Måndagen i veckan som datumet ligger i. */
function startOfWeek(date: Date): Date {
  const result = new Date(date)
  const day = result.getDay()
  const diff = day === 0 ? -6 : 1 - day
  result.setDate(result.getDate() + diff)
  result.setHours(0, 0, 0, 0)
  return result
}

/**
 * Nästa `count` förekomster av en veckodag (0 = söndag, 4 = torsdag).
 * Dagens datum räknas med om det är rätt veckodag.
 */
export function upcomingWeekdayDates(
  weekdayIndex: number,
  count = 8,
  from: Date = new Date(),
): WeekdayOption[] {
  const today = new Date(from)
  today.setHours(0, 0, 0, 0)

  const first = new Date(today)
  const offset = (weekdayIndex - today.getDay() + 7) % 7
  first.setDate(first.getDate() + offset)

  const thisWeekStart = startOfWeek(today).getTime()
  const options: WeekdayOption[] = []

  for (let i = 0; i < count; i++) {
    const date = new Date(first)
    date.setDate(date.getDate() + i * 7)

    const weeksAhead = Math.round(
      (startOfWeek(date).getTime() - thisWeekStart) / (7 * 24 * 60 * 60 * 1000),
    )

    options.push({
      value: toIso(date),
      label: `${date.getDate()} ${MONTHS[date.getMonth()]}`,
      hint:
        weeksAhead === 0
          ? 'Denna vecka'
          : weeksAhead === 1
            ? 'Nästa vecka'
            : '',
    })
  }

  return options
}
